import { useTranslation } from "@next-platform/client-common-core";
import { FilterToggleButton, useMedia } from "@next-platform/client-common-spicy-ui";

import type { SearchTagFilterTriggerProps } from "../types";
import useSearchFilterPanelToggle from "../useSearchFilterPanelToggle";
import { SEARCH_FILTERS_PANEL_ID } from "./constants";
import useFiltersV2State from "./useFiltersV2State";

type SearchFilterToggleV2Props = SearchTagFilterTriggerProps & {
  isTagsDrawerVisible: boolean;
};

const SearchFilterToggleV2 = ({
  tagListMinimized,
  setTagListMinimized,
  setTagsDrawer,
  onlyDesktop = false,
  notDesktop = false,
  isTagsDrawerVisible,
}: SearchFilterToggleV2Props) => {
  const { isDesktop } = useMedia();
  const { t } = useTranslation();
  const { appliedFilterCount } = useFiltersV2State();
  const handleTogglePanel = useSearchFilterPanelToggle({ tagListMinimized, setTagListMinimized, setTagsDrawer });
  const isPanelVisible = isDesktop ? !tagListMinimized : isTagsDrawerVisible;

  if (onlyDesktop && !isDesktop) {
    return null;
  }
  if (notDesktop && isDesktop) {
    return null;
  }

  return (
    <FilterToggleButton
      aria-controls={isPanelVisible ? SEARCH_FILTERS_PANEL_ID : undefined}
      aria-label={t("chatbotFilters:filterToggle.ariaLabel")}
      count={appliedFilterCount}
      countAriaLabel={t("chatbotFilters:filterToggle.appliedCount", { count: appliedFilterCount })}
      data-testid="SearchFilterToggleV2"
      isActive={isPanelVisible}
      onClick={handleTogglePanel}
    />
  );
};

export default SearchFilterToggleV2;
